
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class MessageControl extends Vue {
  @Prop({
    default: "provide a string to messageOptions.text"
  })
  text!: string;
}
